import type { ProductFormulation } from '@/constants/products';
import { DISPENSE_LIMIT_FORMULATIONS } from './constants';

/**
 * Whether pad items of this formulation are totalled into a dispense limit row. Apart from `supportsMaxDailyDose` on
 * purpose, though the two match today: each limit widens to new formulations on its own.
 */
export const supportsDispenseLimit = (formulation: ProductFormulation) => DISPENSE_LIMIT_FORMULATIONS.has(formulation);
